export default __webpack_public_path__ + "static/media/results-energy.68780ea8.jpg";